<template>
  <div class="text-center">
    <v-pagination
        v-model="page"
        :length="total"
        :total-visible="7"
    ></v-pagination>
  </div>
</template>

<script>
export default {
  name: "Paginate",
  props:['total', 'links', 'tableProps'],
  data(){
    return {
      page:1
    }
  },
  watch: {
    page(val) {
      this.$emit('changePage', this.tableProps.page = val)
    }
  }
}
</script>

<style scoped>

</style>